import React, { useEffect, useState, Component } from 'react';
import { LandingPage } from './pages/LandingPage';
import { DDPage } from './pages/DDPage';
import { ReferralPage } from './pages/ReferralPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouReferralPage } from './pages/ThankYouReferralPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PricingProvider } from './contexts/PricingContext';
import { SEO } from './components/SEO';
import { captureUTMParams } from './utils/utm';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  // Capture UTM params on initial load
  useEffect(() => {
    captureUTMParams();
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
      // Re-capture UTM params on navigation
      captureUTMParams();
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // Routing logic
  let PageComponent = DDPage; // Default is now DDPage
  let pageName = 'dd';
  // Normalize path to handle language prefixes (en, ru, ua)
  let normalizedPath = currentPath;
  if (currentPath.startsWith('/ru')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) {
    normalizedPath = currentPath.substring(3);
  }
  if (normalizedPath === '') normalizedPath = '/';
  if (normalizedPath === '/order_website') {
    PageComponent = LandingPage;
    pageName = 'home';
  } else if (normalizedPath === '/referral') {
    PageComponent = ReferralPage;
    pageName = 'referral';
  } else if (normalizedPath === '/privacy') {
    PageComponent = PrivacyPage;
    pageName = 'privacy';
  } else if (normalizedPath === '/terms') {
    PageComponent = TermsPage;
    pageName = 'terms';
  } else if (normalizedPath === '/thank-you') {
    PageComponent = ThankYouPage;
    pageName = 'thankYou';
  } else if (normalizedPath === '/thank-you-referral') {
    PageComponent = ThankYouReferralPage;
    pageName = 'thankYouReferral';
  }
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <PricingProvider data-id="element-2">
          <SEO page={pageName} data-id="element-3" />
          <PageComponent data-id="element-4" />
        </PricingProvider>
      </LanguageProvider>
    </ThemeProvider>;
}